import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { useAccess, useAccountId } from "../Auth/auth-functions";
import { AzureADRoles } from "../Auth/auth-roles";
import { api } from "./api";
import { MutablePreferencesDto, PreferencesDto } from "../models/preferences.models";

export const useGetNotificationPreferencesQuery = () => {
	const hasAccess = useAccess(AzureADRoles.All);
	const accountId = useAccountId();

	return useQuery({
		queryKey: ['preferences', accountId],
		queryFn: async () => {
			let res = await api.get<PreferencesDto>(`/preferences/notifications`);
			return res.data;
		},
		staleTime: 5 * 60 * 1000,
		gcTime: 5 * 60 * 1000,
		enabled: hasAccess
	});
}

export const useUpdateNotificationPreferencesMutation = () => {
	const queryClient = useQueryClient();
	const accountId = useAccountId();

	return useMutation<AxiosResponse<PreferencesDto>, Error, MutablePreferencesDto>({
		mutationFn: (model) => {
			return api.put(`/preferences/notifications`, model);
		},
		onSuccess: (_data, model) => {
			queryClient.setQueryData(['preferences', accountId], (old: PreferencesDto | undefined) => {
				if (old) {
					return {
						...old,
						NotificationPreferences: {
							...old.NotificationPreferences,
							...model.NotificationPreferences
						}
					};
				}
				return {
					NotificationPreferences: { ...model.NotificationPreferences },
					User: (model as any).User ?? {}
				} as PreferencesDto;
			});
		}
	});
}